import posthog from "posthog-js";

export function usePostHog() {
  if (process.env.NODE_ENV === "production") {
    posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
      api_host: "https://eu.i.posthog.com",
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      autocapture: false,
      capture_pageview: false,
      capture_performance: false,
    });
  }

  posthog.__identifiedUserId = null;
  return { posthog };
}
